// JS parses an offsetless date-time as *local* time, so a UTC value that
// arrives without a "Z" lands hours off - west of UTC, in the future. Both chat
// paths now serialize an instant ("2026-09-05T01:18:16.167Z"), but Jackson
// still writes the backend's other LocalDateTime fields without an offset
// (SlideReactionDto.updatedAt, the eventTimestamp on every event payload).
// Every stored time is UTC, so treat a missing offset as UTC.
const HAS_OFFSET = /(?:Z|[+-]\d{2}:?\d{2})$/i;

/**
 * Parse a backend date string into a Date, tolerating both serializations.
 * Pure, so the offset handling is testable without a running backend.
 */
export default function parseServerDate(value) {
    if (value instanceof Date) {
        return value;
    }
    if (typeof value !== 'string') {
        return new Date(value);
    }
    const trimmed = value.trim();
    // Date-only strings ("2026-09-05") are already parsed as UTC by spec; only
    // a date-time without an offset needs the suffix.
    const needsUtc = trimmed.includes('T') && !HAS_OFFSET.test(trimmed);
    return new Date(needsUtc ? `${trimmed}Z` : trimmed);
}
